module.exports = __webpack_public_path__ + "img/ba559e5.svg";